import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";
import { Tooltip } from "./Tooltip";

export function Form({ columns = 1, className, ...rest }: HTMLAttributes<HTMLDivElement> & { columns?: 1 | 2 }) {
  return <div className={cx("ax-form", columns === 2 && "ax-form-2", className)} {...rest} />;
}

export interface FieldProps {
  label: ReactNode;
  htmlFor?: string;
  required?: boolean;
  /** 说明取值含义或单位，与 error 不同时出现。 */
  hint?: ReactNode;
  /** 说明怎么改。 */
  error?: ReactNode;
  /** 参数含义的详细说明，放在标签右侧问号的 Tooltip 里；hint 只写范围与单位。 */
  help?: ReactNode;
  children: ReactNode;
}

export function Field({ label, htmlFor, required, hint, error, help, children }: FieldProps) {
  const labelEl = (
    <label className="ax-field-label" htmlFor={htmlFor}>
      {label}
      {required && <span className="req">*</span>}
    </label>
  );
  return (
    <div className="ax-field">
      {/* 问号放在 label 外面，说明不混进控件的可访问名称 */}
      {help ? <div className="ax-field-head">{labelEl}<FieldHelp>{help}</FieldHelp></div> : labelEl}
      {children}
      {error ? <div className="ax-field-error">{error}</div> : hint ? <div className="ax-field-hint">{hint}</div> : null}
    </div>
  );
}

/** 标签右侧的问号，悬停或聚焦时显示说明。向上弹出：浮层可悬停，朝下会盖住本字段的控件（#343）；上方空间不够时 Tooltip 自动改到下方。 */
function FieldHelp({ children }: { children: ReactNode }) {
  return (
    <Tooltip content={children} align="start" multiline>
      <button type="button" className="ax-field-help" aria-label="说明">?</button>
    </Tooltip>
  );
}

export function Fieldset({ title, children }: { title: ReactNode; children: ReactNode }) {
  return (
    <div className="ax-fieldset">
      <div className="ax-fieldset-title">{title}</div>
      {children}
    </div>
  );
}
